import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { decodeBase64ToText, encodeToBase64 } from '../../utility';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
private http = inject(HttpClient);

  post(url: string, data: any): Observable<any> {
    const payload = { payload: encodeToBase64(JSON.stringify(data)) };
    return this.http.post<any>(url, payload, {withCredentials:true}).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = decodeBase64ToText(res.data);
          return JSON.parse(decodedData);
        }
        throw new Error('Invalid response data');
      })
    );
  }

  postForm(url: string, data: any): Observable<any> {
    const payload = data;
    return this.http.post<any>(url, payload, {withCredentials:true}).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = decodeBase64ToText(res.data);
          return JSON.parse(decodedData);
        }
        throw new Error('Invalid response data');
      })
    );
  }


  get(url: string): Observable<any> {
    return this.http.get<any>(url).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = decodeBase64ToText(res.data);
          return JSON.parse(decodedData)
        }
        throw new Error('Invalid response data');
      })
    );
  }


  put(url: string, data: any): Observable<any> {
    return this.http.put<any>(url, data).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = decodeBase64ToText(res.data);
          return JSON.parse(decodedData);
        }
        throw new Error('Invalid response data');
      })
    );
  }

 
  delete(url: string): Observable<any> {
    return this.http.delete<any>(url).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = decodeBase64ToText(res.data);
          return JSON.parse(decodedData);
        }
        throw new Error('Invalid response data');
      })
    );
  }

  postPure(url: string, data: any): Observable<any> {
    return this.http.post<any>(url, data, {withCredentials:true}).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = res.data;
        }
        throw new Error('Invalid response data');
      })
    );
  }


  postWithDecode(url: string, data: any): Observable<any> {
    return this.http.post<any>(url, data, {withCredentials:true}).pipe(
      map((res) => {
        if (res?.data) {
          const decodedData = decodeBase64ToText(res.data);
          return JSON.parse(decodedData);
        }
        throw new Error('Invalid response data');
      })
    );
  }
  

}
